// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"0bc54ac5","186":"3da3a066","215":"0292fa0c","225":"cf98bc0d","372":"d49368ad","573":"6e38b6da","630":"0ddf2e87","738":"7d016159","743":"7172936e","841":"e9337c4c","856":"4aa6bf8b"}[chunkId] + ".chunk.js";
};